/**
 * Business Web's theme: the shared `@tonnie/design-tokens` provider under the
 * `business` app id — the same provider Citizen Web mounts.
 *
 * It opens Dark (`DEFAULT_THEME_BY_APP.business`) until the person chooses.
 * Only a choice is stored, under `tonnie-business-theme-mode`, and
 * `index.html` paints that same key before React loads. Custom mode carries
 * the tenant's colours and logos, which Settings → Branding activates.
 */
import { APP_IDS, DEFAULT_THEME_BY_APP, ThemeProvider } from '@tonnie/design-tokens';
import type { ReactNode } from 'react';

export function BusinessThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider
      appId={APP_IDS.business}
      defaultTheme={DEFAULT_THEME_BY_APP.business}
      switchable
      enableSystem
      enableCustom
    >
      {children}
    </ThemeProvider>
  );
}
